import React, { useRef, useState, useEffect, useContext } from "react";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FaAddressBook } from "react-icons/fa";
import { FilterMatchMode } from "primereact/api";
import "primeicons/primeicons.css";
import { MultiSelect } from "primereact/multiselect";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { TabView, TabPanel } from "primereact/tabview";
import instance from "../../api/api.js";
import { styleIcone } from "../../shared";
import { IoMdEye } from "react-icons/io";
import { statusConfig } from "../../utils";
import { MdOutlineDelete } from "react-icons/md";
import { useDispatch } from "react-redux";
import { CiEdit } from "react-icons/ci";
import "../../shared/style/constante_style.css";
import { GoPlus } from "react-icons/go";
import { IoPersonOutline } from "react-icons/io5";
import { MenuPoint, ModalDelete } from "../../shared/compoments";
import AllCompomentShared from "../../shared/compoments/AllCompomentShared.jsx";
import { showModal } from "../../store/slice/PrintSlice";
import { modifyPermission } from "../../store/slice/Permission";
import { AuthContext } from "../../context/AuthContext";

function ListePersonnel() {
  const [personnels, setPersonnels] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  //  const dispatch = useDispatch();
  const [allPermission, setAllPermission] = useState([]);
  const getListPersonnel = async () => {
    setIsLoading(true);
    try {
      const response = await instance.get("personnel");
      const responsePermission = await instance.get("permissions");
      console.log("getListPersonnel", response);
      setPersonnels(response.data.data);
      setAllPermission(responsePermission.data.data);
      console.log("responsePermission.data.data", responsePermission.data.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  const ITEMSFILTER = ["nom", "prenom", "phone", "email"];
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    prenom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    nom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    phone: { value: null, matchMode: FilterMatchMode.EQUALS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  useEffect(() => {
    getListPersonnel();
  }, []);

  return (
    <>
      <AllCompomentShared
        libelleHeaderComp={"Liste du personnel"}
        titleStatisticHeaderComp={"Nombre de personnel"}
        nbreTotalStatistiqueComp={personnels.length}
        SearchTableLibelleBtn={"Nouvelle personne"}
        SearchTableIsBtn={true}
        SearchTableIsSearch={true}
        placeholderInputSearch={"Recherche"}
        globalFilterValue={globalFilterValue}
        onGlobalFilterChange={onGlobalFilterChange}
        SearchTableNameRouteBtn={"/personnels/creation"}
        SearchTableIconeBtn={<GoPlus />} //import { GoPlus } from "react-icons/go";
        iconeStatistiqueHeader={<IoPersonOutline fontSize={"2em"} />} //import { IoPersonOutline } from "react-icons/io5";
        isLoading={isLoading}>
        <PersonnelDatatable
          items={personnels}
          allPermission={allPermission}
          itemsForFilter={ITEMSFILTER}
          filters={filters}
          getListPersonnel={getListPersonnel}
        />
      </AllCompomentShared>
    </>
  );
}
function PersonnelDatatable({
  items,
  allPermission,
  getListPersonnel,
  itemsForFilter,
  filters,
}) {
  const dispatch = useDispatch();
  const [idForDelete, setIdForDelete] = useState("");
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const options = [
    {
      name: "Voir plus",
      path: "/personnels/",
      icone: <IoMdEye style={styleIcone} />,
      isIdData: true,
    },
    {
      name: "Gestion des permissions",
      // path: "/creation-bien",
      icone: <FaAddressBook style={styleIcone} />,
      isIdData: false,
      addMethodClick: true,
      methode: (idData) => {
        openModalForPermission(idData);
      },
    },
    {
      name: "Modifier",
      path: "/personnels/edit/",
      icone: <CiEdit style={styleIcone} />,
      isIdData: true,
    },
    {
      name: "Supprimer",
      // path: "/creation-bien",
      icone: <MdOutlineDelete style={styleIcone} />,
      isIdData: true,
      addMethodClick: true,
      methode: (idData) => {
        setIdForDelete(idData);
        dispatch(showModal());
      },
    },
  ];
  const dt = useRef(null);

  const MySwal = withReactContent(Swal);
  const { user } = useContext(AuthContext);
  const [openModal, setOpenModal] = useState(false);
  const [idUserForPermission, setIdUserForPermission] = useState(null);
  // const [selectedPermission, setSelectedPermission] = useState(null);
  const [userId, setUserId] = useState(null);
  const [isLoadingPermission, setIsLoadingPermission] = useState(false);

  const openModalForPermission = (id) => {
    console.log("id", id);
    setUserId(id);
    const tableau = [];
    const element = items.find((el) => Number(el.id) === Number(id));
    const { permissions } = element;
    console.log("permissions2025", permissions);
    permissions.forEach((element) => {
      tableau.push(element.pivot.permission_id);
    });
    console.log("tableau ofPermission", tableau);
    setIdUserForPermission(tableau);
    setOpenModal(true);
  };
  const deletePersonnel = async () => {
    setIsLoadingDelete(true);
    try {
      const response = await instance.delete("/users/" + idForDelete);
      console.log(response);
      if (response.data.status) {
        const index = items.findIndex((item) => item.id === idForDelete);
        items.splice(index, 1);
        dispatch(showModal());
      } else {
        MySwal.fire({
          title: response.data.message,
          icon: "info",
          showConfirmButton: true,
        });
      }
      setIsLoadingDelete(false);
    } catch (error) {
      console.log("error", error);
      setIsLoadingDelete(false);
    }
    console.log(idForDelete);
  };
  const getPermissionUpdate = () => {
    let updatePermission = [];
    allPermission.forEach((item) => {
      idUserForPermission.forEach((element) => {
        if (item.id === element) {
          updatePermission.push(item);
        }
      });
    });
    console.log("updatePermission", updatePermission);
    return updatePermission;
  };
  const modifierPermissionUser = async (idUser) => {
    const data = {
      permissions: idUserForPermission,
    };
    console.log("modifierPermissionUser", data);
    setIsLoadingPermission(true);
    try {
      const response = await instance.put(`/users/${idUser}`, data);
      console.log("modifierPermissionUser", response);
      MySwal.fire({
        title: response.data.message,
        icon: "success",
        showConfirmButton: true,
      });
      // const infoUserForChangeInLocastorage = JSON.parse(localStorage.getItem("permissions"));
      const updatedStoredUser = getPermissionUpdate();
      // const newInfoUserPermission = [...infoUserForChangeInLocastorage,updatedStoredUser]
      if (idUser === user.id) {
        dispatch(modifyPermission(updatedStoredUser));
      } else {
        console.log("pas toi");
      }
      localStorage.setItem("permissions", JSON.stringify(updatedStoredUser));
      console.log("updatedStoredUser", updatedStoredUser);
      setIsLoadingPermission(false);
      getListPersonnel();
    } catch (error) {
      console.log(error);
      setIsLoadingPermission(false);
    }
  };

  const detailsActions = (rowData) => {
    return <MenuPoint optionMenu={options} idData={rowData.id} />;
  };

  const getLastName = (rowData) => {
    return (
      <span>
        {rowData.nom} {rowData.prenom}
      </span>
    );
  };
  const getStatut = (rowData) => {
    return (
      <span
        className="badge text-dark p-3 rounded-5"
        style={{
          background: statusConfig[rowData.role.libelle],
        }}>
        {rowData.role.libelle}
      </span>
    );
  };

  return (
    <div>
      <ModalDelete
        modalTitle={"Voulez-vous vraiment supprimer cet utilisateur ?"}
        isPrintFacture={false}
        isRejectedBtn={false}
        dataInfoForBtn={[
          {
            libelleBtn: isLoadingDelete ? "Loading..." : "Oui",
            color: "error",
            methode: () => {
              deletePersonnel();
            },
          },
          {
            libelleBtn: "Non",
            isStyle: true,
            methode: () => {
              dispatch(showModal());
            },
          },
        ]}
      />
      <>
        {openModal && (
          <div className="conteneur_modal_permission">
            <div className="add_permission">
              <div className="d-flex justify-content-between align-items-center gap-3">
                <h3>Gestion des permissions</h3>
                <h3
                  className="close_add_ville"
                  onClick={() => setOpenModal(false)}>
                  x
                </h3>
              </div>
              <div className="text-start">
                <label htmlFor="profil my-2">Permissions</label>
                <MultiSelect
                  value={idUserForPermission}
                  options={allPermission}
                  optionValue="id"
                  onChange={(e) => {
                    setIdUserForPermission(e.value);
                  }}
                  optionLabel="libelle"
                  placeholder="sélectionne les permissions"
                  className="w-100"
                  display="chip"
                />
              </div>
              <div className="d-flex justify-content-center my-4">
                <button
                  className="btn bg-warning"
                  onClick={() => modifierPermissionUser(userId)}>
                  {isLoadingPermission ? "Chargement..." : "Confirmer"}
                </button>
              </div>
            </div>
          </div>
        )}
      </>
      <TabView>
        <TabPanel>
          <DataTable
            ref={dt}
            value={items}
            tableStyle={{ minWidth: "50rem" }}
            paginator
            rows={10}
            filters={filters}
            globalFilterFields={itemsForFilter}
            // header={header}
          >
            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Nom & prénoms"
              body={getLastName}></Column>
            <Column
              field="phone"
              style={{ textAlign: "center" }}
              header="Contact"></Column>

            <Column
              field="email"
              style={{ textAlign: "center" }}
              header="Email"></Column>
            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="profil"
              body={getStatut}></Column>
            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Actions"
              body={detailsActions}></Column>
          </DataTable>
        </TabPanel>
      </TabView>
    </div>
  );
}

export default ListePersonnel;
